import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-audio",
  "use": "icon-audio-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-audio\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 676.38272c136.07936 0 246.784-110.71488 246.784-246.79424V250.43968c0-136.07936-110.70464-246.784-246.784-246.784s-246.784 110.70464-246.784 246.784v179.15904c0 136.06912 110.70464 246.784 246.784 246.784zM306.176 250.43968c0-113.48992 92.33408-205.824 205.824-205.824s205.824 92.33408 205.824 205.824v179.15904c0 113.50016-92.33408 205.83424-205.824 205.83424s-205.824-92.33408-205.824-205.83424V250.43968z\" p-id=\"4008\" /><path d=\"M871.17824 431.38048V269.6704h-40.96v161.71008c0 175.47264-142.7456 318.21824-318.21824 318.21824-175.4624 0-318.21824-142.7456-318.21824-318.21824V269.6704h-40.96v161.71008c0 191.17056 150.13888 347.904 338.69824 358.5536v177.7152H219.3408v40.96h585.3184v-40.96H532.48V789.93408c188.54912-10.6496 338.69824-167.38304 338.69824-358.5536z\" p-id=\"4009\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/audio.svg
// module id = KyOe
// module chunks = 31